const removeFalsyValues = (object: Record<string, unknown[]>) =>
  Object.fromEntries(
    Object.entries(object)
      .map<[string, unknown[]]>(([key, value]) => [
        key,
        value.filter((arrayValue) => !!arrayValue),
      ])
      .filter(([, value]) => value.length !== 0)
  );

export default removeFalsyValues;
